export default "__VITE_ASSET__DJSMMXfe__"